var slickOptionsMain = {
  centerMode: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  vertical: true,
  verticalSwiping: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false,
        dots: true,
      },
    },
  ],
};
$(function () {
  const current_sku = $('input[type=hidden]#hidden-product-sku').val();
  const product_type = $('input[type=hidden]#hidden-product-type').val();
  const product_is_ready_to_ship = $(
    'input[type=hidden]#hidden-ready-to-ship-enabled'
  ).val();
  const is_rtw = $('input[type=hidden]#hidden-is-rtw').val();
  const have_active_swatch = $('.active-swatch');

  function getColorFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const colorParam = urlParams.get('color');
    if (colorParam) {
      return colorParam;
    }

    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    const productSlug = pathParts[pathParts.length - 1];

    if (productSlug && productSlug.includes('-')) {
      const parts = productSlug.split('-');
      if (parts.length >= 2) {
        const potentialColor = parts.slice(1).join('-');
        return potentialColor;
      }
    }

    const lastClickedColor = localStorage.getItem('lastClickedColor');
    if (lastClickedColor) {
      return lastClickedColor;
    }

    return null;
  }

  function checkColorMatching(urlColor) {
    if (!urlColor) return null;

    const baseLower = urlColor.toLowerCase();
    let matchedSwatch = null;

    $('.swatch-element').each(function () {
      const swatchColor = $(this).attr('data-colorname-value').toLowerCase();
      if (swatchColor === baseLower) {
        matchedSwatch = $(this);
        return false;
      }
    });
    if (!matchedSwatch) {
      const colorJsonUrl =
        document.getElementById('color-json-url')?.value ||
        '/assets/amsale_colors_full.json';

      $.ajax({
        url: colorJsonUrl,
        dataType: 'json',
        async: false,
        success: function (colorDictionary) {
          const baseEntry = colorDictionary[baseLower];

          if (baseEntry && Array.isArray(baseEntry.base)) {
            $('.swatch-element').each(function () {
              const swatchValue = $(this)
                .attr('data-colorname-value')
                .toLowerCase();

              if (
                baseEntry.base.some((baseColor) =>
                  swatchValue.includes(baseColor.toLowerCase())
                )
              ) {
                matchedSwatch = $(this);
                return false;
              }
            });
          }

          if (!matchedSwatch) {
            for (const [colorKey, colorEntry] of Object.entries(
              colorDictionary
            )) {
              if (
                Array.isArray(colorEntry.base) &&
                colorEntry.base.some((b) => b.toLowerCase() === baseLower)
              ) {
                $('.swatch-element').each(function () {
                  const swatchValue = $(this)
                    .attr('data-colorname-value')
                    .toLowerCase();
                  if (
                    swatchValue === colorKey.toLowerCase() ||
                    swatchValue.includes(colorKey.toLowerCase())
                  ) {
                    matchedSwatch = $(this);
                    return false;
                  }
                });

                if (matchedSwatch) break;
              }
            }
          }
        },
      });
    }

    return matchedSwatch;
  }

  function getMatchingSwatches(baseColor) {
    if (!baseColor) return [];

    const baseLower = baseColor.toLowerCase();
    const exact = [];
    const soft = [];
    const availableSwatches = [];
    $('.swatch-element').each(function () {
      availableSwatches.push({
        element: $(this),
        value: $(this).attr('data-colorname-value').toLowerCase(),
        name: $(this).attr('data-value').toLowerCase(),
      });
    });

    let colorJsonUrl = '/assets/amsale_colors_full.json';
    const colorJsonElement = document.getElementById('color-json-url');
    colorJsonUrl = colorJsonElement.value;
    $.ajax({
      url: colorJsonUrl,
      dataType: 'json',
      async: false,
      success: function (colorDictionary) {
        const baseEntry = colorDictionary[baseLower];

        if (baseEntry && Array.isArray(baseEntry.base)) {
          for (const swatch of availableSwatches) {
            if (
              baseEntry.base.some(
                (baseColor) =>
                  swatch.value.includes(baseColor.toLowerCase()) ||
                  swatch.name.includes(baseColor.toLowerCase())
              )
            ) {
              soft.push(swatch.element);
            }
          }
        }

        if (soft.length === 0) {
          for (const [colorKey, colorEntry] of Object.entries(
            colorDictionary
          )) {
            if (Array.isArray(colorEntry.base)) {
              if (
                colorEntry.base.some(
                  (b) =>
                    b.toLowerCase() === baseLower ||
                    b.toLowerCase().includes(baseLower) ||
                    baseLower.includes(b.toLowerCase())
                )
              ) {
                for (const swatch of availableSwatches) {
                  if (
                    swatch.value === colorKey ||
                    swatch.name === colorKey ||
                    swatch.value.includes(colorKey) ||
                    swatch.name.includes(colorKey)
                  ) {
                    soft.push(swatch.element);
                  }
                }
              }
            }
          }
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error(
          'Erreur lors du chargement du dictionnaire de couleurs:',
          textStatus,
          errorThrown
        );
      },
    });

    applyMatchingColor([...exact, ...soft]);

    return [...exact, ...soft];
  }

  function applyMatchingColor(matches) {
    if (matches && matches.length > 0) {
      if ($firstSwatch.hasClass('active-swatch')) {
        $firstSwatch.removeClass('active-swatch');
      }
      matches[0]
        .addClass('active-swatch')
        .find('input')
        .prop('checked', true)
        .change();
      const colorTitle = matches[0].attr('data-colorname-value');
      document.querySelector('#selectedColor').textContent = colorTitle;
    } else {
      $('.swatch-element')
        .first()
        .addClass('active-swatch')
        .find('input')
        .prop('checked', true)
        .change();
    }
  }

  let selected_options = {
    sku: '',
    dress_size: '',
    dress_length: '',
    color: '',
  };
  const urlColor = getColorFromUrl();
  if (urlColor && !have_active_swatch.length) {
    selected_options.color = urlColor;
  }
  $(document).ready(function () {
    const urlColor = getColorFromUrl();
    const multipleColors = $('.swatch-element').length > 1;
    if (urlColor && multipleColors) {
      setTimeout(function () {
        const matchedSwatch = checkColorMatching(urlColor);

        const product = matchedSwatch
          ? matchedSwatch.attr('data-product')
          : null;
        if (matchedSwatch) {
          const redirectLink = matchedSwatch.attr('data-rts-redirect-link');
          if (redirectLink && window.location.pathname !== redirectLink) {
            const resetOptions = {
              sku: '',
              dress_size: '',
              dress_length: '',
              color: matchedSwatch.attr('data-colorname-value'),
            };

            sessionStorage.setItem(
              'selected_options',
              JSON.stringify(resetOptions)
            );
          } else {
            $('.swatch-element').removeClass('active-swatch');
            setSwatchSelectValue(matchedSwatch.attr('data-colorname-value'));
            matchedSwatch
              .addClass('active-swatch')
              .find('input')
              .prop('checked', true)
              .change();

            if (document.querySelector('#selectedColor')) {
              document.querySelector('#selectedColor').textContent =
                matchedSwatch.attr('data-colorname-value');
            }

            if (is_rtw == 'true') {
              fetchProductAndInventoryData(
                matchedSwatch.attr('data-colorname-value')
              );
            }
          }
        }
      }, 500);
    } else {
      $firstSwatch.addClass('active-swatch');
      const colorSwatch = $firstSwatch.attr('data-colorname-value');
      if (colorSwatch) {
        document.querySelector('#selectedColor').textContent = colorSwatch;
      }
    }
    (function () {
      const isRTS =
        $('input[type=hidden]#hidden-ready-to-ship-enabled').val() === 'true';
      if (!isRTS) return;

      function normalizePath(u) {
        try {
          const url = new URL(u, window.location.origin);
          return url.pathname.replace(/\/+$/, '');
        } catch (e) {
          return (u || '').replace(/\/+$/, '');
        }
      }

      function tryRedirectTo(link) {
        if (!link) return;
        const currentPath = normalizePath(window.location.pathname);
        const targetPath = normalizePath(link);

        const loopGuardKey = 'rts_redirected_once';
        if (
          currentPath !== targetPath &&
          !sessionStorage.getItem(loopGuardKey)
        ) {
          sessionStorage.setItem(loopGuardKey, '1');
          window.location.assign(link);
        } else {
          if (currentPath === targetPath)
            sessionStorage.removeItem(loopGuardKey);
        }
      }

      const $active = $('.swatch-element.active-swatch').first();
      if ($active.length) {
        tryRedirectTo($active.attr('data-rts-redirect-link'));
        return;
      }

      const $first = $('.swatch-element').first();
      if ($first.length) {
        tryRedirectTo($first.attr('data-rts-redirect-link'));
      }
    })();
  });
  window.scrollTo(0, 0);
  $(window).on('load', function () {
    window.scrollTo(0, 0);
  });

  // Second level menu scroll animation
  let lastScrollTop = 0;
  let isScrolling = false;

  $(window).on('scroll', function() {
    const scrollTop = $(this).scrollTop();
    console.log('Scroll Top:', scrollTop);
    if (!isScrolling) {
      window.requestAnimationFrame(function() {
        const currentScrollTop = $(window).scrollTop();
        const $secondLevelMenu = $('.second-level-menu');
        
        if ($secondLevelMenu.length) {
          if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
            // Scrolling down - hide menu
            $secondLevelMenu.addClass('menu-hidden');
          } else if (currentScrollTop < lastScrollTop) {
            // Scrolling up - show menu
            $secondLevelMenu.removeClass('menu-hidden');
          }
        }
        
        lastScrollTop = currentScrollTop;
        isScrolling = false;
      });
    }
    isScrolling = true;
  });

  if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
    $('.product-select--dress-length select').prop('disabled', true);
  }

  const singleOptionSelector = document.querySelector(
    'select[aria-label="Dress Length"]'
  );
  const targetElement = document.querySelector(
    '.form-control.product-form__selects.product-select--dress-length.product-select--RTS'
  );

  if (singleOptionSelector && singleOptionSelector.options.length <= 1) {
    targetElement.style.display = 'none';
  }
  let $firstSwatch = $('.swatch-element').first();

  if (!have_active_swatch.length) {
    if (selected_options.color != '') {
      getMatchingSwatches(selected_options.color);
    } else {
      $firstSwatch.addClass('active-swatch');

      let redirectLink = $firstSwatch.attr('data-rts-redirect-link');
      if (redirectLink && window.location.href !== redirectLink) {
        if (!sessionStorage.getItem('redirected')) {
          sessionStorage.setItem('redirected', 'true');
          window.location = redirectLink;
        } else {
          sessionStorage.removeItem('redirected');
          window.location.reload();
        }
      }
    }
  }
  if (!have_active_swatch.length && !selected_options.color) {
    let $firstSwatch = $('.swatch-element').first();
    if ($firstSwatch.length) {
      let redirectLink = $firstSwatch.attr('data-rts-redirect-link');
      if (redirectLink) {
        sessionStorage.removeItem('selected_options');
        window.location.href = redirectLink;
      } else {
        $firstSwatch
          .addClass('active-swatch')
          .find('input')
          .prop('checked', true)
          .change();
      }
    }
  }
  const session_exists = sessionStorage.getItem('selected_options');
  if (session_exists && current_sku == JSON.parse(session_exists).sku) {
    selected_options.sku = JSON.parse(session_exists).sku;
    selected_options.dress_size = JSON.parse(session_exists).dress_size;
    selected_options.dress_length = JSON.parse(session_exists).dress_length;
    selected_options.color = JSON.parse(session_exists).color;

    if (selected_options.dress_size != '') {
      const size_select =
        $('.infinite-option-size-select select').length > 0
          ? $('.infinite-option-size-select select')
          : $('.product-select--size select');

      if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
        // DO NOTHING
      } else {
        size_select.val(selected_options.dress_size);
      }

      if (product_type == 'dress-by-color') {
        $('.custom-dropdown .selected span').text(selected_options.dress_size);
      }
    }

    if (selected_options.dress_length != '') {
      $('.product-select--dress-length select').val(
        selected_options.dress_length
      );
    }

    setVariantID(selected_options.dress_size, selected_options.dress_length);
    handleEnableAddToCart();
  } else {
    selected_options.sku = current_sku;
    sessionStorage.setItem(
      'selected_options',
      JSON.stringify(selected_options)
    );
    handleEnableAddToCart();
  }

  // Init Tooltips
  if ($('.colorSelector').length > 0 || $('.exclusive-readonly').length > 0) {
    $('.tooltip').tooltipster({
      theme: 'tooltipster-noir',
      maxWidth: 250,
      animation: 'grow',
    });
  }

  if ($('.product-template__container').length > 0) {
    var alternatePaymentSliderOption = {
      vertical: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      infinite: true,
      dots: false,
      arrows: false,
      autoplay: true,
      speed: 2000,
      adaptiveHeight: true,
    };

    var slider = $('.alternate-payments-slider').slick(
      alternatePaymentSliderOption
    );

    // Thumbnail slider
    var slickOptions = {
      vertical: true,
      verticalSwiping: false,
      centerMode: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
    };

    let isSliding = false;

    var slickOptionsProductMain = {
      centerMode: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
    };

    var sliderMain = $('.image-main').slick(slickOptionsMain);

    var sliderProduct = $('.slider-main').slick(slickOptionsProductMain);
    if (window.innerWidth < 992) {
      console.log('init slick vertical');

      slider.on('beforeChange', function () {
        isSliding = true;
      });

      sliderMain.on('beforeChange', function () {
        isSliding = true;
      });
      sliderProduct.on('beforeChange', function () {
        isSliding = true;
      });
      slider.on('afterChange', function (event, slick, currentSlide) {
        isSliding = false;
        setSliderDotActive(currentSlide);
        slider.slick('slickGoTo', currentSlide);
      });

      sliderMain.on('afterChange', function (event, slick, currentSlide) {
        isSliding = false;
        setSliderDotActive(currentSlide);
        sliderMain.slick('slickGoTo', currentSlide);

        if ($(window).width() > 992) {
          const $imgMain = $('.image-main');
          const cleanup = $imgMain.data('scrollbar-cleanup');
          if (cleanup) {
            cleanup();
            setTimeout(initNativeScrollBar, 50);
          }
        }
      });

      sliderProduct.on('afterChange', function (event, slick, currentSlide) {
        isSliding = false;
        setSliderDotActive(currentSlide);
        sliderProduct.slick('slickGoTo', currentSlide);
      });
    }
    function initNativeScrollBar() {
      const $imgMain = $('.image-main');
      if (!$imgMain.length) return;
      if (
        !$('.product-template__container').length &&
        !$('.product-single').length
      ) {
        return;
      }

      if ($imgMain.hasClass('slick-initialized')) {
        $imgMain.slick('unslick');
      }

      const cleanup = $imgMain.data('scrollbar-cleanup');
      if (cleanup) cleanup();
      $('.desktop-scrollbar').remove();

      let selectedColor = '';

      const $activeSwatch = $('.swatch-element.active-swatch');
      if ($activeSwatch.length) {
        selectedColor = $activeSwatch.attr('data-colorname-value') || '';
      }

      if (!selectedColor && $imgMain.hasClass('slick-initialized')) {
        const currentSlide = $imgMain.slick('slickCurrentSlide');
        const $currentSlide = $imgMain.find('.slide').eq(currentSlide);
        selectedColor = $currentSlide.data('color') || '';
      }

      if (!selectedColor) {
        selectedColor = $imgMain.find('.slide').first().data('color') || '';
      }

      selectedColor = selectedColor.toString().toLowerCase();

      const $allSlides = $imgMain.find('.slide');
      const $visibleSlides = $allSlides.filter(function () {
        const color = ($(this).data('color') || '').toString().toLowerCase();
        return color === selectedColor;
      });

      const $noSwatchVisibleSlides = $allSlides.filter(function () {
        const color = ($(this).data('color') || '').toString().toLowerCase();
        return color !== '';
      });

      const visibleColorCount = Math.max(
        1,
        $visibleSlides.length || $noSwatchVisibleSlides.length
      );
      console.log('Visible color count:', $noSwatchVisibleSlides.length);
      if (visibleColorCount <= 1) {
        console.log('📷 Only one image, no scrollbar needed');
        return;
      }

      $allSlides.each(function () {
        const slideColor = ($(this).data('color') || '')
          .toString()
          .toLowerCase();
        if (slideColor === selectedColor) {
          $(this).show();
        }
      });

      const $firstImg =
        $visibleSlides.first().find('img') ||
        $noSwatchVisibleSlides.first().find('img');
      let imageHeight = $firstImg.height() || $firstImg[0]?.naturalHeight;
      const viewportHeight = $(window).height();
      $imgMain.css({
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
        scrollBehavior: 'smooth',
        border: 'none',
        outline: 'none',
        gap: '20px',
        maxHeight: Math.min(imageHeight * visibleColorCount) + 'px',
      });

      $visibleSlides.css({
        display: 'block',
        width: '100%',
        height: imageHeight + 'px',
        flexShrink: 0,
        maxHeight: viewportHeight - 175 + 'px',
      });
      $noSwatchVisibleSlides.css({
        display: 'block',
        width: '100%',
        height: imageHeight + 'px',
        flexShrink: 0,
        maxHeight: viewportHeight - 175 + 'px',
      });

      $imgMain[0].offsetHeight;

      const containerHeight = $imgMain.outerHeight();
      const scrollbarHeight = Math.min(300, containerHeight * 0.8);
      const thumbHeight = Math.max(20, scrollbarHeight / visibleColorCount);

      const $scrollbar = $(`
        <div class="desktop-scrollbar" style="
        display: none !important;
          position: absolute;
          left: 30px;
          top: 0;
          height: ${scrollbarHeight}px;
          width: 2px;
          border-radius: 2px;
          z-index: 10;
          opacity: 1;
        ">
          <div class="desktop-scrollbar-thumb" style="
            height: ${thumbHeight}px;
            width: 100%;
            border-radius: 2px;
            cursor: pointer;
            position: absolute;
            
            transition: all 0.3s ease;
            z-index: 2;
          "></div>
        </div>
      `);

      $imgMain.css('position', 'relative').append($scrollbar);
      const $thumb = $scrollbar.find('.desktop-scrollbar-thumb');
      // Utiliser la bonne liste d'images visibles (swatch ou non)
      function getGlobalVisibleSlides() {
        // Priorité à $visibleSlides si non vide, sinon $noSwatchVisibleSlides
        if ($visibleSlides.length > 0) return $visibleSlides;
        return $noSwatchVisibleSlides;
      }

      function updateThumbPosition() {
        let closestIndex = 0;
        let minDiff = Infinity;
        const pageScrollTop =
          window.scrollY || document.documentElement.scrollTop;
        const $globalSlides = getGlobalVisibleSlides();
        $globalSlides.each(function (index) {
          const slideRect = this.getBoundingClientRect();
          const slideTopAbs = pageScrollTop + slideRect.top;
          const diff = Math.abs(pageScrollTop - slideTopAbs);
          if (diff < minDiff) {
            minDiff = diff;
            closestIndex = index;
          }
        });
        let thumbTop = 0;
        if (visibleColorCount > 1) {
          const segmentHeight =
            (scrollbarHeight - thumbHeight) / (visibleColorCount - 1);
          thumbTop = closestIndex * segmentHeight;
        }
        $thumb.css('top', `${thumbTop}px`);
      }

      function scrollToImage(index) {
        const $globalSlides = getGlobalVisibleSlides();
        const $target = $globalSlides.eq(index);
        if ($target.length) {
          const header = $('header');
          const headerHeight = header.length ? header.outerHeight() : 0;
          const targetRect = $target[0].getBoundingClientRect();
          const pageScrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const targetTopAbs = pageScrollTop + targetRect.top;
          const scrollTo = Math.max(0, targetTopAbs - headerHeight - 20);
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
          setTimeout(function () {
            updateThumbPosition();
          }, 300);
        }
      }

      function updateScrollbarPosition() {
        const pageScrollTop = $(window).scrollTop();
        const containerRect = $imgMain[0].getBoundingClientRect();
        const containerTop = containerRect.top + pageScrollTop;
        const containerHeight = containerRect.height;
        const viewportHeight = $(window).height();

        let visibleTop = Math.max(0, pageScrollTop - containerTop);
        let visibleBottom = Math.min(
          containerHeight,
          pageScrollTop + viewportHeight - containerTop
        );
        let visibleHeight = Math.max(0, visibleBottom - visibleTop);

        if (visibleHeight > 0) {
          let scrollbarTop;
          const firstSlide = $visibleSlides[0] || $noSwatchVisibleSlides[0];
          const lastSlide = $visibleSlides[$visibleSlides.length - 1];
          if (firstSlide) {
            const firstSlideRect = firstSlide.getBoundingClientRect();
            const header = $('header');
            const headerHeight = header.length ? header.outerHeight() : 0;
            if (firstSlideRect.top - headerHeight < 30 && !lastSlide) {
              scrollbarTop =
                visibleTop +
                (firstSlideRect.height - scrollbarHeight) / 2 -
                100;
            } else {
              scrollbarTop =
                visibleTop + (firstSlideRect.height - scrollbarHeight) / 2;
            }
          } else {
            scrollbarTop =
              visibleTop + (firstSlideRect.height - scrollbarHeight) / 2;
          }
          $scrollbar.css('top', Math.max(0, scrollbarTop) + 'px');
          $scrollbar.css('opacity', 1);
        } else {
          $scrollbar.css('opacity', 0);
        }
      }

      // Store function for external access
      $imgMain.data('scrollbar-update-thumb', updateThumbPosition);
      $imgMain.data('scrollbar-update-position', updateScrollbarPosition);

      // Synchroniser le thumb avec le scroll global de la page
      $(window)
        .off('scroll.customScrollbar')
        .on('scroll.customScrollbar', function () {
          updateThumbPosition();
          updateScrollbarPosition();
        });

      $scrollbar.on('click.customScrollbar', function (e) {
        const rect = this.getBoundingClientRect();
        const clickY = e.clientY - rect.top;
        console.log('Scrollbar clicked at Y:', visibleColorCount);
        const segmentHeight =
          (scrollbarHeight - thumbHeight) / (visibleColorCount - 1);
        let index = Math.round(clickY / segmentHeight);
        index = Math.max(0, Math.min(visibleColorCount - 1, index));
        scrollToImage(index);
      });

      let isDragging = false,
        startY = 0,
        startThumbTop;
      $thumb.on('mousedown.customScrollbar', function (e) {
        e.preventDefault();
        isDragging = true;
        startY = e.clientY;
        startThumbTop = parseFloat($thumb.css('top'));
        $(document.body).addClass('dragging');
      });
      $(document).on('mousemove.customScrollbarDrag', function (e) {
        if (!isDragging) return;
        const deltaY = e.clientY - startY;
        const segmentHeight =
          (scrollbarHeight - thumbHeight) / (visibleColorCount - 1);
        let newThumbTop = Math.max(
          0,
          Math.min(scrollbarHeight - thumbHeight, startThumbTop + deltaY)
        );
        let index = Math.round(newThumbTop / segmentHeight);
        index = Math.max(0, Math.min(visibleColorCount - 1, index));
        $thumb.css('top', `${index * segmentHeight}px`);
        scrollToImage(index);
      });
      $(document).on('mouseup.customScrollbarDrag', function () {
        if (!isDragging) return;
        isDragging = false;
        $(document.body).removeClass('dragging');
      });

      $imgMain.data('scrollbar-scroll-to-image', scrollToImage);
      // Hover effects

      // Initial update
      setTimeout(function () {
        updateThumbPosition();
        updateScrollbarPosition();
      }, 100);

      // Update on image load
      $visibleSlides.find('img').on('load.customScrollbar', function () {
        setTimeout(function () {
          updateThumbPosition();
          updateScrollbarPosition();
        }, 200);
      });

      // Cleanup function
      $imgMain.data('scrollbar-cleanup', function () {
        $imgMain.off('.customScrollbar');
        $(window).off('.customScrollbar');
        $(document).off('.customScrollbarDrag');
        $scrollbar.remove();

        // Reset container styles
        $imgMain.css({
          height: '',
          overflowY: '',
          overflowX: '',
          position: '',
          scrollBehavior: '',
          border: '',
          outline: '',
        });

        // Reset slide styles
        $allSlides
          .css({
            display: '',
            width: '',
            minHeight: '',
            marginBottom: '',
          })
          .show();
      });
    }

    function handleResponsiveScroll() {
      const $imgMain = $('.image-main');

      if ($(window).width() > 992) {
        // Only initialize on product pages
        if (
          $('.product-template__container').length ||
          $('.product-single').length
        ) {
          // Cleanup old scrollbar first
          const cleanup = $imgMain.data('scrollbar-cleanup');
          if (cleanup) cleanup();

          // Check if we have multiple images for the selected color
          let selectedColor =
            $('.swatch-element.active-swatch').attr('data-colorname-value') ||
            '';
          selectedColor = selectedColor.toString().toLowerCase();

          const $visibleSlides = $imgMain.find('.slide').filter(function () {
            const color = ($(this).data('color') || '')
              .toString()
              .toLowerCase();
            return color === selectedColor;
          });
          const $noSwatchVisibleSlides = $imgMain
            .find('.slide')
            .filter(function () {
              const color = ($(this).data('color') || '')
                .toString()
                .toLowerCase();
              return color !== '';
            });
          console.log(
            'Visible slides for color',
            selectedColor,
            ':',
            $visibleSlides.length
          );
          if ($visibleSlides.length > 1 || $noSwatchVisibleSlides.length > 1) {
            setTimeout(initNativeScrollBar, 100);
          }
        }
      } else {
        const cleanup = $imgMain.data('scrollbar-cleanup');
        if (cleanup) cleanup();

        if (!$imgMain.hasClass('slick-initialized')) {
          $imgMain.slick(slickOptionsMain);
        }
      }
    }
    handleResponsiveScroll();
    $(window).on('resize', handleResponsiveScroll);
    $('.control-down').on('click', function () {
      if (isSliding) {
        return;
      }

      if ($(window).width() > 992) {
        const $imgMain = $('.image-main');
        const scrollToImage = $imgMain.data('scrollbar-scroll-to-image');
        if (scrollToImage) {
          const selectedColor =
            $('.swatch-element.active-swatch').attr('data-colorname-value') ||
            '';
          const $visibleSlides = $imgMain.find('.slide').filter(function () {
            const color = ($(this).data('color') || '')
              .toString()
              .toLowerCase();
            return color === selectedColor.toLowerCase();
          });
          const $noSwatchVisibleSlides = $imgMain
            .find('.slide')
            .filter(function () {
              const color = ($(this).data('color') || '')
                .toString()
                .toLowerCase();
              return color !== '';
            });
          const currentScrollTop = $imgMain.scrollTop();
          let currentIndex = 0;

          // Find current image index
          $visibleSlides.each(function (index) {
            const slideTop = $(this).position().top + $imgMain.scrollTop();
            if (slideTop <= currentScrollTop + 50) {
              currentIndex = index;
            }
          });
          $noSwatchVisibleSlides.each(function (index) {
            const slideTop = $(this).position().top + $imgMain.scrollTop();
            if (slideTop <= currentScrollTop + 50) {
              currentIndex = index;
            }
          });

          const nextIndex = Math.min(
            currentIndex + 1,
            $noSwatchVisibleSlides.length - 1 || $visibleSlides.length - 1
          );
          scrollToImage(nextIndex);
        }
      } else {
        // Mobile: use Slick
        slider.slick('next');
        sliderMain.slick('next');
        sliderProduct.slick('next');
      }
    });

    $('.control-up').on('click', function () {
      if (isSliding) {
        return;
      }

      if ($(window).width() > 992) {
        const $imgMain = $('.image-main');
        const scrollToImage = $imgMain.data('scrollbar-scroll-to-image');
        if (scrollToImage) {
          const selectedColor =
            $('.swatch-element.active-swatch').attr('data-colorname-value') ||
            '';
          const $visibleSlides = $imgMain.find('.slide').filter(function () {
            const color = ($(this).data('color') || '')
              .toString()
              .toLowerCase();
            return color === selectedColor.toLowerCase();
          });

          const currentScrollTop = $imgMain.scrollTop();
          let currentIndex = 0;

          $visibleSlides.each(function (index) {
            const slideTop = $(this).position().top + $imgMain.scrollTop();
            if (slideTop <= currentScrollTop + 50) {
              currentIndex = index;
            }
          });

          const prevIndex = Math.max(currentIndex - 1, 0);
          scrollToImage(prevIndex);
        }
      } else {
        // Mobile: use Slick
        slider.slick('prev');
        sliderMain.slick('prev');
        sliderProduct.slick('prev');
      }
    });

    var swatch = {
      elements: $('.swatch-element'),
    };
    swatch.elements.on('click keyup', function (e) {
      if (e.type === 'click' || (e.type === 'keyup' && e.keyCode === 13)) {
        const selected_swatch = $(this)
          .attr('data-colorname-value')
          .toLowerCase();
        swatch.elements.each(function () {
          $(this).removeClass('active-swatch');
        });

        selected_options.dress_size = '';
        selected_options.dress_length = '';
        selected_options.color = selected_swatch;

        sessionStorage.setItem(
          'selected_options',
          JSON.stringify(selected_options)
        );
        handleEnableAddToCart();

        $('.product-select--size select').val('').trigger('change');
        $('.product-select--dress-length select').val('').trigger('change');
        $('.custom-dropdown .selected span.current-selected-value').text('');

        if (is_rtw == 'true') {
          fetchProductAndInventoryData(selected_swatch);
        }

        $('.swatch-element').removeClass('active-swatch');
        $(this).addClass('active-swatch');

        if ($(window).width() > 992) {
          // Update scrollbar for new color immediately
          setTimeout(function () {
            const header = $('header');
            const headerHeight = header.outerHeight();
            const imgMain = $('.image-main');
            const imgMainOffset = imgMain.offset().top;
            window.scrollTo({
              top: imgMainOffset - headerHeight - 20,
              behavior: 'smooth',
            });

            // Reinitialize scrollbar for new color
            const cleanup = imgMain.data('scrollbar-cleanup');
            if (cleanup) cleanup();

            setTimeout(initNativeScrollBar, 100);
          }, 150);
        }

        if (product_is_ready_to_ship === 'true') {
          selected_options = {
            sku: '',
            dress_size: '',
            dress_length: '',
            color: '',
          };
          sessionStorage.setItem(
            'selected_options',
            JSON.stringify(selected_options)
          );
          window.location = $(this).attr('data-rts-redirect-link');
        }
      }
    });

    // Handle Quantity input Add/Substract events
    const quantity_input = $('input.product-form__qty');
    $('button.quantity-btn').on('click', function (e) {
      e.preventDefault();
      let current_quantity = quantity_input.val();

      if ($(this).hasClass('add-qty')) {
        current_quantity++;
      } else {
        current_quantity--;
      }
      if (current_quantity <= 0) {
        current_quantity = 1;
      }

      quantity_input.val(current_quantity);
      return false;
    });

    let is_boldmetrics =
      $('input[type=hidden]#hidden-product-boldmetrics-enabled').val() ===
      'true';
    if ($('.size-chart-link-popup').length > 0) {
      $('.size-chart-link-popup').magnificPopup({
        type: 'inline',
        midClick: true,
      });

      if (is_boldmetrics) {
        $('.fit-link-modal').on('click', function (e) {
          e.preventDefault();
          $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
          return false;
        });
      }
    }

    // Delivery Date Service
    const collectionName = $(
      'input[type=hidden]#hidden-product-collection'
    ).val();

    $(document).ready(function () {
      $.ajax({
        url:
          'https://store.b2b.amsale.com/delivery_date_check/' +
          collectionName +
          '?platform=b2c',
        context: document.body,
        success: function (data) {
          var currentDate = new Date(data.value.toString());
          var formattedDate = moment.utc(currentDate).format('L');
          const hidden_eta_input = $('#hidden-product-estimated-date');
          const is_holiday =
            $('.estimated-delivery-date.is-holiday-date').length > 0;
          const eta_date_element = $(
            '.estimated-delivery-date p#delivery_service_desc'
          );
          eta_date_element.attr('data-mto-date', formattedDate);

          if (!is_holiday) {
            eta_date_element.find('span.delivery-date').text(formattedDate);
            hidden_eta_input.val(eta_date_element.data()?.mtoDate);
          } else {
            hidden_eta_input.val(eta_date_element.data()?.holidayDate);
          }
        },
        error: function (msg) {
          console.log('status', msg.status);
          console.log('statusText', msg.statusText);
        },
      });
    });

    // Add to Cart Submit Click Handler
    $('button[type=submit].product-form__cart-submit').on(
      'click',
      function (e) {
        if ($('.colorSelector').length > 0) {
          if ($('.swatch-element.active-swatch').length <= 0) {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Color missing',
              'Please select a color.'
            );
            return false;
          }
        }

        if ($('.custom-ddlist').length > 0) {
          if (
            $('.custom-ddlist .custom-dropdown .selected span').html() === ''
          ) {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Size missing',
              'Please select a size.'
            );
            return false;
          }
        }

        if ($('form.product-form .product-select--size select').length > 0) {
          if ($('.product-select--size select').val() == '') {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Size missing',
              'Please select a size.'
            );
            return false;
          }
        }
        if (
          infiniteOptionsSizeSelect && infiniteOptionsSizeSelect?.html().length > 0
        ) {
          if ($('.spb-select select').val() == '') {
            e.preventDefault();
            $('#infiniteoptions-container').addClass('select-error');
            displayUserFeedbackMessage(
              'error',
              'Size missing',
              'Please select a size.'
            );
            return false;
          }
        }

        if (
          $('form.product-form .product-select--dress-length select').length > 0
        ) {
          if ($('.product-select--dress-length select').val() == '') {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Dress Length missing',
              'Please select a length.'
            );
            return false;
          }
        }
      }
    );

    document.arrive('.infinite-option-size-select select', function () {
      if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
        $(this).prop('disabled', true);
      } else {
        if (selected_options.color != '') {
          $(this).prop('disabled', false);
        }

        if (selected_options.dress_size != '') {
          $(this).val(selected_options.dress_size);
          $(this).prop('disabled', false);
        }
      }

      handleEnableAddToCart();
    });

    $(document).on(
      'change',
      '.infinite-option-size-select select',
      function () {
        if (document.readyState == 'complete') {
          if ($(this).val() != '') {
            $('#infiniteoptions-container').removeClass('select-error');
          }

          selected_options.dress_size = $(this).val();
          sessionStorage.setItem(
            'selected_options',
            JSON.stringify(selected_options)
          );
          handleEnableAddToCart();
        }
      }
    );

    $(document).on('change', '.product-select--size select', function () {
      if (document.readyState == 'complete') {
        selected_options.dress_size = $(this).val();
        sessionStorage.setItem(
          'selected_options',
          JSON.stringify(selected_options)
        );
        handleEnableAddToCart();
      }
    });

    $(document).on(
      'change',
      '.product-select--dress-length select',
      function () {
        if (document.readyState == 'complete') {
          selected_options.dress_length = $(this).val();
          sessionStorage.setItem(
            'selected_options',
            JSON.stringify(selected_options)
          );
          handleEnableAddToCart();
        }
      }
    );

    // Custom Ready-to-Ship Dropdown Events
    const custom_select = $('.custom-dropdown .selected');
    const down_arrow = $('.custom-dropdown .selected svg');
    custom_select.on('click keypress', function (e) {
      const dropdown = $(this).next();

      if (dropdown.is(':visible')) {
        dropdown.hide();
        down_arrow.removeClass('active');
      } else {
        dropdown.show();
        down_arrow.addClass('active');
      }
    });

    $(document).bind('click', function (e) {
      var $clicked = $(e.target);
      if (!$clicked.parents().hasClass('custom-dropdown')) {
        custom_select.next().hide();
      }
    });

    $(document).on('keyup', function (evt) {
      if (evt.keyCode == 27) {
        custom_select.next().hide();
      }
    });

    $(document).on(
      'click keypress',
      '.custom-dropdown .ddlist-options ul li',
      function () {
        $('.custom-dropdown .ddlist-options ul li').removeClass(
          'active-selection'
        );
        const AddToCartButton = $('button.product-form__cart-submit');
        const klaviyoButton = $('button.klaviyo_popup_trigger');
        if (!$(this).hasClass('disabled')) {
          $(this).addClass('active-selection');
          const hidden_eta_input = $('#hidden-product-estimated-date');
          const hidden_saletype = $(
            'input[type=hidden]#product-properties-saletype'
          );
          const eta_date_element = $(
            '.estimated-delivery-date p#delivery_service_desc'
          );
          const is_holiday =
            $('.estimated-delivery-date.is-holiday-date').length > 0;
          const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();

          if ($(this).hasClass('rts')) {
            if (is_pre_order) {
              hidden_saletype.val('Preorder');
            } else {
              hidden_eta_input.val(eta_date_element.data().instockDate);
              hidden_saletype.val('In Stock');
              AddToCartButton.show();
              klaviyoButton.hide();
            }
          } else {
            if ($(this).hasClass('rtw')) {
              AddToCartButton.hide();
              klaviyoButton.show();
            }
            if (!is_holiday) {
              hidden_eta_input.val(eta_date_element.data().mtoDate);
            } else {
              hidden_eta_input.val(eta_date_element.data().holidayDate);
            }
            hidden_saletype.val('Made to Order');
          }

          custom_select
            .find('span.current-selected-value')
            .text($(this).find('span.variant-value').text());
          custom_select.next().hide();
          $('.product-select--size select')
            .val($(this).find('span.variant-value').text())
            .change();
          $('.product-form__variants').val($(this).data('variant-id'));
          let url = new URL(window.location.href);
          url.searchParams.set('variant', $(this).data('variant-id'));
          window.history.replaceState(null, null, url);
        }
      }
    );

    if ($('.product-select--RTS').length > 0) {
      const product_id = $('.custom-dropdown .ddlist-options ul').data(
        'product-id'
      );
      if (product_id) {
        const active_swatch = $('.swatch-element.active-swatch');
        let active_color = null;

        if (active_swatch.length > 0) {
          active_color = active_swatch.attr('data-colorname-value');
          if (active_color) {
            active_color = active_color.toLowerCase();
          }
        }

        const api_endpoint = `https://api.ecom.amsale.com/api/inventory/${product_id}`;

        $.ajax({
          type: 'GET',
          url: api_endpoint,
          dataType: 'json',
          success: function (data, textStatus) {
            if (
              textStatus === 'success' &&
              data &&
              data.inventory &&
              data.inventory.length > 0
            ) {
              if (is_rtw === 'true' && active_color) {
                fetchProductAndInventoryData(active_color);
                generateDropdownHTML(data.inventory, null, active_color);
              } else {
                generateDropdownHTML(data.inventory);
              }
            } else {
              console.warn('No valid inventory data received.');
            }
          },
          error: function () {
            displayUserFeedbackMessage(
              'error',
              'Error',
              'Sorry. An error occurred.<br>Please refresh the page<br>and try again.'
            );
          },
        });
      }
    }
  }
  // Fermeture du if ($('.product-template__container').length > 0)
});

// ============================================
// UTILITY FUNCTIONS
// ============================================

function setSliderDotActive(goToIndex) {
  const active_index = parseInt($('.slider-dot.active').data('slide-index'));
  $('.slider-dot').eq(active_index).removeClass('active');
  $('.slider-dot').eq(goToIndex).addClass('active');
}

function setSwatchSelectValue(value) {
  $('.product-select--color select.single-option-selector')
    .val(capitalizeFirstLetters(value))
    .trigger('change');
}

function capitalizeFirstLetters(str) {
  return str
    .split('-')
    .map(function (item) {
      return item.charAt(0).toUpperCase() + item.slice(1);
    })
    .join('-');
}

function handleEnableAddToCart() {
  const size_select =
    $('.infinite-option-size-select select').length > 0
      ? $('.infinite-option-size-select select')
      : $('.product-select--size select');
  const length_select = $('.product-select--dress-length select');
  const swatch_selectors = $('.colorSelector');
  const collectionName = $(
    'input[type=hidden]#hidden-product-collection'
  ).val();
  let valid_state = false;

  if (
    swatch_selectors.length == 0 &&
    size_select.length == 0 &&
    length_select.length == 0
  ) {
    valid_state = true;
  } else if (
    swatch_selectors.length > 0 &&
    size_select.length == 0 &&
    length_select.length == 0
  ) {
    if (swatch_selectors.find('.active-swatch').length > 0) {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length > 0 &&
    size_select.length > 0 &&
    length_select.length > 0
  ) {
    if (
      swatch_selectors.find('.active-swatch').length > 0 &&
      size_select.val() != '' &&
      length_select.val() != ''
    ) {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length > 0 &&
    size_select.length > 0 &&
    length_select.length == 0
  ) {
    if (
      swatch_selectors.find('.active-swatch').length > 0 &&
      size_select.val() != ''
    ) {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length == 0 &&
    size_select.length > 0 &&
    length_select.length == 0
  ) {
    if (size_select.val() != '') {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length == 0 &&
    size_select.length > 0 &&
    length_select.length > 0
  ) {
    if (size_select.val() != '' && length_select.val() != '') {
      valid_state = true;
    }
  }

  if (
    $('.product__price dd span.price-item--regular')
      .text()
      .includes('Sold out') ||
    $('button.product-form__cart-submit span').text().includes('Sold out')
  ) {
    valid_state = true;
  }

  if (valid_state) {
    $('button.product-form__cart-submit').prop('disabled', false);
  } else if (!valid_state && collectionName === 'private-sale') {
    $('button.product-form__cart-submit').prop('disabled', true);
  }
}

function getCurrentColor() {
  let element = null;

  if ($('.colorSelector').length > 0) {
    element = $('.colorSelector');
  } else if ($('.product-form__selects.product-select--color').length > 0) {
    element = $('.product-form__selects.product-select--color');
  }

  if (element) {
    if (element.hasClass('colorSelector')) {
      return element.find('.active-swatch').attr('data-colorname-value');
    } else {
      return element.find('select.single-option-selector').val();
    }
  }

  return false;
}

function escapeRegExpMatch(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isExactMatch(str, match) {
  return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str);
}

function setVariantID(dress_size, dress_length) {
  let full_search_query = '';

  if (getCurrentColor() !== false && dress_size !== '' && dress_length !== '') {
    if ($('.product-form__selects.product-select--size').length > 0) {
      full_search_query = `${getCurrentColor()} / ${dress_size} / ${dress_length}`;
    } else {
      full_search_query = `${getCurrentColor()} / ${dress_length}`;
    }
  } else if (
    getCurrentColor() !== false &&
    dress_size == '' &&
    dress_length !== ''
  ) {
    full_search_query = `${getCurrentColor()} / ${dress_length}`;
  } else if (
    getCurrentColor() !== false &&
    dress_size !== '' &&
    dress_length == ''
  ) {
    if ($('.product-form__selects.product-select--size').length > 0) {
      full_search_query = `${getCurrentColor()} / ${dress_size}`;
    } else {
      full_search_query = getCurrentColor();
    }
  } else if (
    getCurrentColor() !== false &&
    dress_size == '' &&
    dress_length == ''
  ) {
    full_search_query = getCurrentColor();
  } else if (getCurrentColor() == false && dress_size !== '') {
    full_search_query = dress_size;
  }

  if (full_search_query !== '') {
    $('select.product-form__variants option').each(function () {
      if (isExactMatch(full_search_query, $(this).text())) {
        $('select.product-form__variants').val($(this).val());
      }
    });
  }
}

function setGlobalSkuOnClick(sku) {
  if ($('#hidden-is-rtw').val()) {
    $('#hidden-product-sku').val(sku);
  }
}

function generateDropdownHTML(
  inventoryData,
  productData = null,
  selectedColor = null
) {
  if (!inventoryData || inventoryData.length === 0) {
    console.warn('⚠ No inventory data found!');
    return;
  }
  const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();
  const custom_ddl = $('.custom-dropdown .ddlist-options ul');
  const soldout = custom_ddl.data('sold-out');
  const rtw = productData?.product?.template_suffix;
  let DDL_html = '';
  let addedSizes = new Set();

  inventoryData.forEach((item) => {
    const { variant_id, available, size, location } = item;
    if (['XL', 'SS', 'MM'].includes(size) || !location?.includes('318')) {
      return;
    }

    let matching_variant = productData
      ? productData.product.variants.find((v) => v.id == variant_id)
      : null;

    if (
      selectedColor &&
      (!matching_variant ||
        matching_variant.option1.toLowerCase() !== selectedColor.toLowerCase())
    ) {
      return;
    }

    let color = matching_variant ? matching_variant.option1 : 'Unknown';
    let listItemClass = available
      ? 'option rts'
      : soldout && rtw
      ? 'option rtw'
      : 'option mto';
    let statusText = available
      ? is_pre_order
        ? 'Pre Order'
        : 'In Stock'
      : soldout
      ? 'Sold Out'
      : 'Made to Order';
    if (
      listItemClass == 'option rtw' ||
      (listItemClass == 'option rts' && rtw)
    ) {
      statusText = '';
    }

    let sizeKey = `${size}-${color}`;

    if (!addedSizes.has(sizeKey)) {
      DDL_html += `
        <li class="${listItemClass}" tabindex="0" 
            data-variant-id="${variant_id}" data-color="${color}" onclick="setGlobalSkuOnClick('${matching_variant?.sku}')">
            <span class="variant-value">${size}</span>
            <span>${statusText}</span>
        </li>
      `;
      addedSizes.add(sizeKey);
    }
  });

  custom_ddl.html(DDL_html);
  $('.custom-dropdown span.loading-data').removeClass('loading');
}

function fetchProductAndInventoryData(selectedColor = null) {
  const product_id = $('.custom-dropdown .ddlist-options ul').data(
    'product-id'
  );
  if (!product_id) {
    console.error('Error: Product ID not found!');
    return;
  }

  const productHandle = window.location.pathname.split('/').pop();
  const productUrl = `/products/${productHandle}.json`;
  const inventoryUrl = `https://api.ecom.amsale.com/api/inventory/${product_id}`;

  Promise.all([
    fetch(productUrl)
      .then((res) => res.json())
      .catch((err) => console.error('❌ Error fetching product data:', err)),
    fetch(inventoryUrl)
      .then((res) => res.json())
      .catch((err) => console.error('❌ Error fetching inventory data:', err)),
  ])
    .then(([productData, inventoryData]) => {
      if (!productData?.product?.variants) {
        console.error('Invalid productData format!', productData);
        return;
      }

      const inventoryArray = inventoryData.inventory;
      if (!Array.isArray(inventoryArray)) {
        console.error(
          'Extracted inventoryArray is not an array!',
          inventoryArray
        );
        return;
      }

      const variantLookup = new Set(
        productData.product.variants.map((variant) => variant.id)
      );

      if (selectedColor) {
        const matchingVariant = productData.product.variants.find(
          (v) => v.option1.toLowerCase() === selectedColor.toLowerCase()
        );

        if (!matchingVariant) {
          console.warn('⚠ No matching variant found for color:', selectedColor);
          return;
        }

        $('#hidden-variant-id').val(matchingVariant.id);

        const filteredInventory = inventoryArray.filter((item) =>
          variantLookup.has(item.variant_id)
        );

        const sizeDropdown = $('.product-select--size select');
        const customDropdownList = $('.custom-dropdown .ddlist-options ul');
        customDropdownList.empty();

        const addedSizes = new Set();

        if (filteredInventory.length > 0) {
          $('.current-selected-value').text('Select Size');
          filteredInventory.forEach(({ size, variant_id }) => {
            if (!addedSizes.has(size)) {
              addedSizes.add(size);
              sizeDropdown.append(`<option value="${size}">${size}</option>`);
              customDropdownList.append(
                `<li role="option" tabindex="0" data-variant-id="${variant_id}" data-color="${selectedColor}">${size}</li>`
              );
            }
          });

          sizeDropdown.prop('disabled', false);
          $('.custom-dropdown .selected span').prop('disabled', false);
        } else {
          sizeDropdown.append('<option value="">No sizes available</option>');
          $('.custom-dropdown .selected span').styles.color = 'blue';
        }

        generateDropdownHTML(filteredInventory, productData, selectedColor);
        updateProductImages(matchingVariant.id, productData);
      } else {
        generateDropdownHTML(inventoryArray, productData);
      }
    })
    .catch((error) => console.error('Error fetching data:', error));
}

function updateProductImages(variantId, productData) {
  if (!variantId || !productData) {
    console.error('Missing variantId or productData');
    return;
  }

  const matchingVariant = productData.product.variants.find(
    (v) => String(v.id) === String(variantId)
  );
  if (!matchingVariant) {
    console.warn('No matching variant found in productData');
    return;
  }

  const selectedColor = matchingVariant.option1;

  // DESKTOP VERSION (> 992px)
  if ($(window).width() > 992) {
    let firstVisibleSlide = null;
    let visibleCount = 0;

    $('.image-main .slide').each(function () {
      const slideColor = $(this).attr('data-color');
      if (slideColor === selectedColor) {
        $(this).show();
        visibleCount++;
        if (!firstVisibleSlide) {
          firstVisibleSlide = $(this);
        }
      } else {
        console.log('Hiding slide with color:', slideColor);
        $(this).hide();
      }
    });

    if (firstVisibleSlide && visibleCount > 0) {
      setTimeout(function () {
        if (typeof initNativeScrollBar === 'function') {
          initNativeScrollBar();
        }
      }, 1000);
    } else {
      console.warn('Aucune image trouvée pour la couleur:', selectedColor);
      // remove any existing desktop scrollbar if there are no matching slides
      try {
        const $imgMain = $('.image-main');
        $imgMain.find('.desktop-scrollbar').remove();
        $imgMain.css({ overflow: '', height: '' });
      } catch (e) {
        // ignore
      }
    }
  }
  // MOBILE VERSION (≤ 992px)
  else {
    if ($('.image-main').hasClass('slick-initialized')) {
      $('.image-main').slick('unslick');
    }

    $('.image-main').css('opacity', '0');

    let hasMatchingSlides = false;
    let firstVisibleIndex = -1;

    $('.image-main .slide').each(function (index) {
      const slideColor = $(this).attr('data-color');
      if (
        slideColor &&
        selectedColor &&
        slideColor.toLowerCase() === selectedColor.toLowerCase()
      ) {
        $(this).show();
        hasMatchingSlides = true;
        if (firstVisibleIndex === -1) {
          firstVisibleIndex = index;
        }
      } else {
        console.log('Hiding slide with color:', slideColor);
        $(this).hide();
      }
    });

    if (!hasMatchingSlides) {
      $('.image-main .slide').show();
      firstVisibleIndex = 0;
    }

    setTimeout(function () {
      $('.image-main').slick(slickOptionsMain);

      setTimeout(function () {
        if ($('.image-main').hasClass('slick-initialized')) {
          $('.image-main').slick('slickGoTo', firstVisibleIndex, false);
          setTimeout(function () {
            $('.image-main').css('opacity', '1');
          }, 100);
        }
      }, 100);
    }, 50);
  }
}

function setHiddenFieldValues() {
  const current_sku = $('input[type=hidden]#hidden-product-sku').val();
  const eta_date_element = $(
    '.estimated-delivery-date p#delivery_service_desc'
  );
  const hidden_eta_input = $('#hidden-product-estimated-date');
  const session_exists = sessionStorage.getItem('selected_options');
  const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
  if (session_exists && current_sku == JSON.parse(session_exists).sku) {
    current_dress_size = JSON.parse(session_exists).dress_size;

    const custom_options = $('.custom-dropdown .ddlist-options ul li');
    custom_options.each(function (index) {
      if ($(this).find('span.variant-value').text() === current_dress_size) {
        if ($(this).hasClass('mto')) {
          if (!is_holiday) {
            hidden_eta_input.val(eta_date_element.data().mtoDate);
          } else {
            hidden_eta_input.val(eta_date_element.data().holidayDate);
          }
          $('input[type=hidden]#product-properties-saletype').val(
            'Made to Order'
          );
        } else {
          $('input[type=hidden]#product-properties-saletype').val('In Stock');
          hidden_eta_input.val(eta_date_element.data().instockDate);
        }
      }
    });
  }
}

document.querySelectorAll('.detailBox .content a').forEach((link) => {
  const text = link.textContent.trim().toLowerCase();

  let is_boldmetrics =
    $('input[type=hidden]#hidden-product-boldmetrics-enabled').val() === 'true';

  if (text.includes('size guide')) {
    link.classList.add('size-chart-link-popup');
    link.href = '#size-guide';
    link.addEventListener('click', (e) => {
      e.preventDefault();
      $('.size-chart-link-popup').magnificPopup({
        type: 'inline',
        midClick: true,
      });
    });
  }

  if (text.includes('fit check tool')) {
    link.classList.add('fit-link-modal');
    link.href = '#fit-check-tool';

    link.addEventListener('click', (e) => {
      e.preventDefault();
      $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
      return false;
    });
  }
  if (text.includes('measure')) {
    link.href =
      'https://amsale.com/blogs/amsale/how-to-measure-your-dress-size';
    link.target = '_blank';
  }
});
